import { LitElement, html, css} from 'lit';
import {property, customElement} from 'lit/decorators.js';
import { SvgIcons } from '../../voyage-svg-icons/src/voyage-svg-icons';
import { voyageCursorStyles } from '../../voyage-style/src/voyage-style';

@customElement('voyage-checkbox')
export class VoyageCheckbox extends LitElement
{
    @property({type: Boolean}) checked: boolean = false;
    @property({type: String}) label: string = "";
    @property({type: Boolean}) disabled: boolean = false;
    @property({type: Boolean}) noOverflow: boolean = false;

    static get styles()
    {
        return [
            voyageCursorStyles,
            css`
            :host {
                width: fit-content;
                height: fit-content;
                display: flex;
                flex-direction: row;
                align-items: center;
            }

            label {
                font-size: 14px;
                color: var(--neutrals-grey-02, black);
                font-family: MaerskText;
                cursor: pointer;
            }

            label[no-overflow] {
                width: 50px;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
            }

            label[disabled] {
                cursor: not-allowed;
            }

            #container {
                position: relative;
                width: 16px;
                height: 16px;
                margin-right: 3px;
                color: var(--neutrals-grey-10, white);
                margin-right: 8px;
            }

            #container[disabled] {
                color: var(--neutrals-grey-02, black);
            }

            input {
                display: block;
                box-sizing: border-box;
                width: 100%;
                height: 100%;
                border: 1px solid var(--neutrals-grey-06, grey);
                border-radius: 2.5px;
                appearance: none;
                -webkit-appearance: none;
                background: none;
                margin: 0;
                padding: 0;
            }

            input:checked {
                background-color: var(--primary-blue-05, blue);
            }

            input:disabled {
                background-color: var(--neutrals-grey-08, blue);
            }

            svg {
                box-sizing: border-box;
                position: absolute;
                display: block;
                top: 0;
                left: 0;
                height: 100%;
                width: 100%;
                padding: 2px;
                fill: currentColor;
                pointer-events: none;
            }
            `
        ]
    }

    render()
    {
        return html`
        <div id="container" ?disabled=${this.disabled}>
            <input id="input" type="checkbox" ?disabled=${this.disabled}
                   .checked=${this.checked} @input=${ (evt: InputEvent) => this.checked = (<HTMLInputElement>evt.target).checked }>
            ${ this.checked ? SvgIcons.check : "" }
        </div>
        <label for="input" ?no-overflow=${this.noOverflow} ?disabled=${this.disabled}>${this.label}</label>
        `;
    }
}
